<div class="form-group mb-0 d-flex justify-content-start align-items-center">
    <label class="font-small-3 font-weight-500 mb-0 me-25" *ngIf="label">
        {{ label }}
    </label>
    <div class="position-relative" #categoryTreeDropdownRef>
        <!-- Trigger Button -->
        <button
            (click)="toggleCategoryTreeDropdown()"
            class="btn bg-white text-start d-flex justify-content-between align-items-center"
            style="padding: 0.438rem 0rem; white-space: nowrap;"
        >
            <span class="selected-category">{{ categorySelectedLabel }}</span>
        </button>


        <!-- Dropdown Panel -->
        <div *ngIf="isCategoryTreeOpen" 
             class="position-absolute bg-white border categories-dropdoen-penal rounded custom-scrollbar">
            <!-- Recursive Template Outlet -->
            <ng-container *ngTemplateOutlet="categoryTreeNodeTemplate; context: { nodes: resolvedCategories, level: 0 }"></ng-container>
        </div>
    </div>
</div>

<!-- Recursive Tree Node Template -->
<ng-template #categoryTreeNodeTemplate let-nodes="nodes" let-level="level">
    <div *ngFor="let node of nodes">
        <div 
            class="d-flex align-items-center categories-li cursor-pointer"
            [style.paddingLeft.px]="level * 20 + 12"
            [style.paddingRight.px]="12"
            [style.paddingTop.px]="8"
            [style.paddingBottom.px]="8"
            [style.backgroundColor]="selectedCategoryId === node.id ? '#e7f3ff' : 'transparent'"
            [style.transition]="'background-color 0.15s'"
            (click)="handleCategoryTreeSelect(node)"
            (mouseenter)="selectedCategoryId !== node.id && ($event.currentTarget.style.backgroundColor='#f8f9fa')"
            (mouseleave)="selectedCategoryId !== node.id && ($event.currentTarget.style.backgroundColor='transparent')"
        >
            <!-- Expander Arrow -->
            <ng-container *ngIf="hasCategoryChildren(node); else expanderSpacer">
                <div 
                    (click)="toggleCategoryExpand($event, node)"
                    class="d-flex align-items-center justify-content-center flex-shrink-0"
                    [style.width.px]="16"
                    [style.height.px]="16"
                    [style.marginRight.px]="6"
                    style="cursor: pointer;"
                >
                    <svg 
                        [style.transform]="isCategoryExpanded(node) ? 'rotate(90deg)' : 'rotate(0deg)'"
                        style="width: 10px; height: 10px; transition: transform 0.2s; color: #6e6b7b;" 
                        fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                </div>
            </ng-container>
            <ng-template #expanderSpacer>
                <div
                    class="d-flex align-items-center justify-content-center flex-shrink-0"
                    [style.width.px]="16"
                    [style.height.px]="16"
                    [style.marginRight.px]="6"
                ></div>
            </ng-template>

            <!-- Icon based on content -->
            <span class="d-flex align-items-center me-75 flex-shrink-0">
                <ng-container *ngIf="hasCategoryChildren(node); else fileIcon">
                    <!-- Folder Icon -->
                    <svg height="16" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                    </svg>
                </ng-container>
                <ng-template #fileIcon>
                    <!-- FileText Icon -->
                    <svg height="16" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                </ng-template>
            </span>

            <span class="category_name">
                {{ node.category_name }}
            </span>
        </div>

        <!-- Recursive Children -->
        <div *ngIf="hasCategoryChildren(node) && isCategoryExpanded(node)">
            <ng-container *ngTemplateOutlet="categoryTreeNodeTemplate; context: { nodes: node.children, level: level + 1 }"></ng-container>
        </div>
    </div>
</ng-template>
